import type { Lang } from "@noli/core";

export enum Setting_Words {
  "Setting" = "Setting",
  "Back-to-Space" = "Back-to-Space",
  "Account" = "Account",
  "Password*" = "Password*",
  "Change-Password" = "Change-Password",
  "Space" = "Space",
  "Avatar" = "Avatar",
  "Choose-Image" = "Choose-Image",
  "Reset-Image" = "Reset-Image",
  "Background" = "Background",
  "Display-Name*" = "Display-Name*",
  "Edit-Name" = "Edit-Name",
  "Summary" = "Summary",
  "Edit-Summary" = "Edit-Summary",
  "Send-code" = "Send-code",
  "Confirm" = "Confirm",
  "Enter-verification-code" = "Enter-verification-code",
  "Please-enter-6-30-digit-password" = "Please-enter-6-30-digit-password",
  "Password" = "Password",
  "Verification" = "Verification",
  "Change-Succeeded" = "Change-Succeeded",
  "Binding-Succeeded" = "Binding-Succeeded",
  "No-Available" = "No-Available",
  "Enter" = "Enter",
}

export const SettingLangRecords: Record<Lang, Record<Setting_Words, string>> = {
  zh: {
    [Setting_Words["Setting"]]: "个人设置",
    [Setting_Words["Back-to-Space"]]: "返回我的空间",
    [Setting_Words["Account"]]: "账号登录信息",
    [Setting_Words["Password*"]]: "密码",
    [Setting_Words["Change-Password"]]: "更换密码",
    [Setting_Words["Space"]]: "个人空间信息",
    [Setting_Words["Avatar"]]: "头像",
    [Setting_Words["Choose-Image"]]: "选择图片",
    [Setting_Words["Reset-Image"]]: "初始化",
    [Setting_Words["Background"]]: "背景",
    [Setting_Words["Display-Name*"]]: "姓名（昵称）",
    [Setting_Words["Edit-Name"]]: "编辑姓名",
    [Setting_Words["Summary"]]: "个性签名",
    [Setting_Words["Edit-Summary"]]: "编辑签名",
    [Setting_Words["Send-code"]]: "获取验证码",
    [Setting_Words["Confirm"]]: "确认",
    [Setting_Words["Enter-verification-code"]]: "请输入短信验证码",
    [Setting_Words["Please-enter-6-30-digit-password"]]: "请输入6位-30位密码",
    [Setting_Words["Password"]]: "密码",
    [Setting_Words["Verification"]]: "验证码",
    [Setting_Words["Change-Succeeded"]]: "修改成功",
    [Setting_Words["Binding-Succeeded"]]: "绑定成功",
    [Setting_Words["No-Available"]]: "暂无",
    [Setting_Words["Enter"]]: "请输入",
  },
  en: {
    [Setting_Words["Setting"]]: "Setting",
    [Setting_Words["Back-to-Space"]]: "Back to Space",
    [Setting_Words["Account"]]: "Account",
    [Setting_Words["Password*"]]: "Password*",
    [Setting_Words["Change-Password"]]: "Change Password",
    [Setting_Words["Space"]]: "Space",
    [Setting_Words["Avatar"]]: "Avatar",
    [Setting_Words["Choose-Image"]]: "Choose Image",
    [Setting_Words["Reset-Image"]]: "Reset Image",
    [Setting_Words["Background"]]: "Background",
    [Setting_Words["Display-Name*"]]: "Display Name*",
    [Setting_Words["Edit-Name"]]: "Edit",
    [Setting_Words["Summary"]]: "Summary",
    [Setting_Words["Edit-Summary"]]: "Edit",
    [Setting_Words["Send-code"]]: "Send code",
    [Setting_Words["Confirm"]]: "Confirm",
    [Setting_Words["Enter-verification-code"]]: "Enter verification code",
    [Setting_Words["Please-enter-6-30-digit-password"]]: "Please enter 6-30 digit password",
    [Setting_Words["Password"]]: "Password",
    [Setting_Words["Verification"]]: "Verification",
    [Setting_Words["Change-Succeeded"]]: "Change Succeeded!",
    [Setting_Words["Binding-Succeeded"]]: "Binding-Succeeded!",
    [Setting_Words["No-Available"]]: "No Available",
    [Setting_Words["Enter"]]: "Enter ",
  },
};
